import React, { useState } from "react";
import { loginRequest } from "./msalConfig";
import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, Shield } from "lucide-react";
import './AuthService.css';
import { useAuth } from "./AuthContext";

const AuthService: React.FC = () => {
  const { user, setUser, instance } = useAuth(); // Use the global user state
  const [, setAccessToken] = useState<string | null>(null); // Access token state
  const navigate = useNavigate();

  // Handle login
  const login = async () => {
    try {
      console.log("Login initiated");
      const loginResponse = await instance.loginPopup(loginRequest);
      setUser(loginResponse.account);
      setAccessToken(loginResponse.accessToken);
      console.log("Login successful", loginResponse);
      // Restore the route the user was on before being redirected to login
      let postLoginRedirect = sessionStorage.getItem('postLoginRedirect') || '/';
      if (!(postLoginRedirect.startsWith('/') && !postLoginRedirect.startsWith('//'))) {
        postLoginRedirect = '/';
      }
      sessionStorage.removeItem('postLoginRedirect');
      navigate(postLoginRedirect);
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  // Handle logout
  const logout = async () => {
    try {
      await instance.logoutPopup();
      setUser(null);
      setAccessToken(null);
      console.log("Logout successful");
      navigate("/"); // Redirect after logout
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  // Login Page
  if (!user) {
    return (
        <div className="auth-div">
          <div>
            <Shield/>
            <h2>
              Sign in to Your Account
            </h2>
            <p>
              Secure login system
            </p>
          </div>
          <div>
            <button
              onClick={login}
              className="btn auth-btn"
            >
              <LogIn />
              Sign in
            </button>
          </div>
        </div>
    );
  }

  // Logout/User Page
  return (
      <div className="auth-div">
        <div>
          <h2>
            Welcome, {user.name}
          </h2>
          <p>Logged in</p>
        </div>
        <div>
          <button
            onClick={logout}
          className="btn auth-btn"
          >
            <LogOut/>
            Sign Out
          </button>
        </div>
      </div>
  );

};

export default AuthService;
